import { render, staticRenderFns } from "./Impressao.vue?vue&type=template&id=dfa49410"
import script from "./Impressao.vue?vue&type=script&lang=js"
export * from "./Impressao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports